<template>
  <el-cascader
    v-model="selectedOptions"
    expand-trigger="hover"
    :options="options"
    :style="{ width: width }"
    clearable
    :props="cascaderProp"
    :placeholder="placeholder"
    :show-all-levels="false"
    @change="handleChange"
    @remove-tag="handleRemoveTag"
    @blur="handleBlur"
    @visible-change="handleVisibleChange"
  />
</template>

<script>
import {
  provinceAndCityData,
  TextToCode,
  CodeToText
} from "element-china-area-data"
import emitter from "element-ui/src/mixins/emitter"

export default {
  name: "FAreaMultiplePicker",
  mixins: [emitter],
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    width: {
      type: String,
      default: "100%"
    },
    placeholder: {
      type: String,
      default: "选择地区"
    },
    type: {
      type: String,  // selectedDisabled:选中且禁用选项 默认不传选择地址不触发禁用
      default: ""
    },
    disabledOptions: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      options: provinceAndCityData.map(item => {
        return {
          label: item.label,
          value: item.value,
          disabled: this.disabledOptions.includes(item.label)
        };
      }),
      cascaderProp: {
        multiple: true
      },
      areaData: {},
      tags: []
    };
  },

  computed: {
    selectedOptions: {
      get() {
        if (this.value.length) {
          return this.value.map(item => {
            return [item[0] ? TextToCode[item[0]].code : []]
          })
        } else {
          return []
        }
      },
      set(val) {
        if (val.length) {
          this.$emit('input', this.toText(val))
        } else {
          this.$emit('input', [])
        }
      }
    },
  },

  watch: {
    disabledOptions: {
      handler(newVal) {
        if (this.type === 'selectedDisabled') return
        this.options = this.options.map(item => {
          // 获取value中已选中的选项
          const valueOptions = this.value.map(item => item[0]);
          // 排除当前选择器中已选的选项
          const disabledOptions = newVal.filter(option => !valueOptions.includes(option));
          return {
            ...item,
            disabled: disabledOptions.includes(item.label)
          }
        })
      },
      immediate: true
    }
  },

  methods: {
    handleChange(val) {
      const textValue = this.toText(val)
      const resVal = {
        oldVal: this.value,
        newVal: textValue,
        diffVal: this.getRemovedOptions(this.value, textValue)
      }
      this.emitCheckEvent('change', resVal)
      this.emitCheckEvent('blur', resVal)
    },
    handleBlur(event) {
      this.$emit('blur', event)
    },
    handleVisibleChange(visible) {
      if (!visible) {
        this.emitCheckEvent('blur', this.value)
      }
    },
    emitCheckEvent(event, val) {
      this.$emit(event, val)
      this.dispatch('ElFormItem', `el.form.${event}`, [val])
    },
    toText(val) {
      return val.map(item => {
        return [CodeToText[item[0]]]
      })
    },
    handleRemoveTag(val) {
      this.$emit('remove-tag', val.map(item => {
        return [CodeToText[item]]
      }))
    },
    // 比较数组元素差异
    getRemovedOptions(oldArr, newArr) {
      if (!Array.isArray(oldArr) || !Array.isArray(newArr)) return []
      const normalize = (arr) =>
        arr
          .map(item => (Array.isArray(item) ? item[0] : item))
          .filter(val => val !== undefined && val !== null && val !== '')
      const oldValues = normalize(oldArr)
      const newValues = normalize(newArr)
      const oldSet = new Set(oldValues)
      const newSet = new Set(newValues)
      const diff = []
      oldValues.forEach(val => {
        if (!newSet.has(val)) {
          diff.push([val])
        }
      })
      newValues.forEach(val => {
        if (!oldSet.has(val)) {
          diff.push([val])
        }
      })
      return diff
    },
  },
}
</script>

<style lang="scss" scoped></style>
